const quickLinks: { id: number; label: string; href: string; icon: string }[] = [
  { id: 1, label: "最新实锤", href: "#feed", icon: "ri-flashlight-line" },
  { id: 2, label: "热度榜", href: "#ranking", icon: "ri-fire-line" },
  { id: 3, label: "达人名录", href: "#directory", icon: "ri-contacts-line" },
  { id: 4, label: "社区讨论", href: "#community", icon: "ri-chat-3-line" },
];

export default function TopEntryBar() {
  return (
    <div className="hidden bg-primary-950 text-background-100 md:block">
      <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-between px-6 text-xs">
        <div className="flex items-center gap-5">
          <span className="flex items-center gap-1.5 font-medium text-accent-300">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-pulse-line"></i>
            </span>
            实时更新中
          </span>
          {quickLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="flex cursor-pointer items-center gap-1 text-background-200 transition-colors hover:text-background-50"
            >
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className={link.icon}></i>
              </span>
              {link.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-5">
          <a
            href="#community"
            className="flex cursor-pointer items-center gap-1 text-background-200 transition-colors hover:text-background-50"
          >
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-notification-3-line"></i>
            </span>
            订阅更新
          </a>
          <a
            href="#community"
            className="flex cursor-pointer items-center gap-1 font-medium text-accent-300 transition-colors hover:text-accent-200"
          >
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-upload-2-line"></i>
            </span>
            上报黑料
          </a>
        </div>
      </div>
    </div>
  );
}